import React from "react";
import { render } from "react-dom";
import App from "@router";
import "normalize.css";
import { ThemeProvider } from "@emotion/react";
import { register } from "./ServiceWorker";
import { Fonts } from "@styles/fonts";
import { theme } from "@styles/theme";
import { AppProvider } from "@context";
const Component = (
  <AppProvider>
    <ThemeProvider theme={theme}>
      <Fonts>
        <App />
      </Fonts>
    </ThemeProvider>
  </AppProvider>
);
const root = document.getElementById("root");

render(Component, root);

register();
